import md5 from 'md5';

const hasGravatar = (email, callback) => {
  if (!email) return false;
  const emailhash = md5(email);
  const gravatar_url = 'https://www.gravatar.com/avatar/' + emailhash + '?d=404';
  const http = new XMLHttpRequest();
  http.onload = e => {
    if (http.readyState === 4) callback(http.status);
  };
  http.onerror = e => {
    console.error(http.statusText);
  };
  http.open('HEAD', gravatar_url, true);
  http.send();
};

export default hasGravatar;
